import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IndianRupee } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PageTitle, BigButton } from "@/components/Layout";

export default function Rates() {
  const { t } = useApp();
  const [mats, setMats] = useState(null);
  useEffect(() => { api.get("/meta").then((r) => setMats(r.data.materials || [])).catch(() => setMats([])); }, []);
  return (
    <div className="space-y-4" data-testid="rates-page">
      <PageTitle sub={t("Live rates per kg, the same for everyone. Final amount is based on the actual weight at pickup.")}>{t("Today's scrap rates")}</PageTitle>
      <div className="overflow-hidden rounded-3xl border border-[#D2E0D8] bg-white">
        {mats?.map((m, i) => (
          <div key={m.name} className={`flex items-center justify-between px-5 py-3 ${i ? "border-t border-[#EAF1EC]" : ""}`} data-testid={`rate-row-${m.name.replace(/\W+/g, "-").toLowerCase()}`}>
            <span className="font-semibold text-[#0D3B2B]">{t(m.name)}</span>
            <span className="flex items-center font-display text-lg font-extrabold text-[#2E9E6B]"><IndianRupee className="h-4 w-4" />{m.price || 0}<span className="ml-1 text-xs font-normal text-[#7B968B]">/kg</span></span>
          </div>
        ))}
      </div>
      <p className="text-xs text-[#7B968B]">{t("Your pickup partner may agree a slightly different rate with you at pickup. Your receipt always shows the standard and agreed rate.")}</p>
      <Link to="/book"><BigButton coral data-testid="rates-book-btn">{t("Request doorstep pickup")}</BigButton></Link>
    </div>
  );
}
